<script>
  /** @type {boolean} */
  export let isBallotMeasure
  /** @type {boolean} */
  export let face
  /** @type {boolean} */
  export let isPresident

  let voteLabel = 'total';

</script>

<thead>
  <tr>

      <th scope="col" colspan={1} class="contest__candidate-header"></th>

    <th scope="col" colspan={face ? 2 : 1} class="contest__candidate-header">
      {isBallotMeasure ? 'Support' : 'Candidate'}
    </th>
    <th scope="col" class="contest__candidate-header text-left">
      <span>% votes</span>
    </th>
    {#if !isPresident}
    <th scope="col" class="contest__candidate-header text-right">
      {voteLabel}
    </th>
    {/if}
    {#if isPresident}
    <th scope="col" class="contest__candidate-header text-right pres-total">
      {voteLabel}
    </th>
    <th scope="col" class="contest__candidate-header text-right border-left">
      <span class="invisible">Delegates</span>
    </th>
    {/if}
  </tr>
</thead>
